// Material Kit 2 React pages
import Blog from "pages/LandingPages/Blog";

export default function BlogPage() {
  return <Blog />;
}
